<ph-card *ngIf="payload" flat [heading]="title" [subheading]="subtitle || ''" role="region" [attr.aria-label]="title">
    <ph-stack>
        <ph-hint *ngIf="periodLabel">{{ periodLabel }}</ph-hint>

        <ph-columns *ngIf="highlights.length > 0" min="160px">
            <ph-stat-card *ngFor="let highlight of highlights; trackBy: trackByHighlightKey"
                          [label]="highlight.label"
                          [value]="highlight.formattedValue"></ph-stat-card>
        </ph-columns>

        <ph-facts *ngIf="checks.length > 0">
            <ph-fact *ngFor="let check of checks; trackBy: trackByCheckKey">
                <ph-label>{{ check.label }}</ph-label>
                <ph-toolbar nowrap>
                    <ph-status-badge variant="light" [status]="checkBadge(check.status)">{{ checkLabel(check.status) }}</ph-status-badge>
                    <ph-hint *ngIf="check.formattedDifference || check.detail">{{ check.formattedDifference || check.detail }}</ph-hint>
                </ph-toolbar>
            </ph-fact>
        </ph-facts>

        <ph-stack gap="tight" *ngFor="let table of tables; trackBy: trackByTableKey">
            <ph-label>{{ table.title }}</ph-label>
            <ph-data-table [label]="table.title" [columns]="tableColumns(table)" [rows]="tableRows(table)"></ph-data-table>
            <ph-toolbar *ngIf="table.truncated" justify="between">
                <ph-hint>Showing {{ table.returnedCount }} of {{ table.totalCount ?? table.returnedCount }}</ph-hint>
                <ph-button *ngIf="table.csvUrl" variant="secondary" mode="filled" size="small" icon="download-simple" (click)="openCsv(table.csvUrl)">
                    Download all {{ table.csvRowCount ?? table.totalCount }}
                </ph-button>
            </ph-toolbar>
        </ph-stack>

        <ph-alert *ngFor="let warning of warnings; trackBy: trackByWarningKey" status="warning" variant="lighter" size="small">{{ warning.message }}</ph-alert>
    </ph-stack>
</ph-card>
